const courseList = [
  {
    id: "python",
    title: "Python Programming",
    shortDesc: "From Basics to Advanced Applications",
    duration: "2 Months",
    price: "₹ 9,999",
    image: "https://cdn-icons-png.flaticon.com/512/5968/5968350.png",
    details: [
      "Basics of Python, Data Structures",
      "OOPs, File Handling",
      "Mini Projects & Final Project"
    ],
    highlights: [
      "Real-Time Examples",
      "Assignments + Projects",
      "Completion Certificate"
    ]
  },
  {
    id: "java",
    title: "Java Full Stack",
    shortDesc: "From Core Java to Spring Boot & React",
    duration: "3 Months",
    price: "₹ 11,999",
    image: "https://cdn-icons-png.flaticon.com/512/226/226777.png",
    details: [
      "Core Java, Collections, OOPs",
      "Spring Boot, REST API",
      "React Integration & Final Project"
    ],
    highlights: [
      "Hands-on Backend + Frontend",
      "Mock Interviews",
      "Certification + Resume Building"
    ]
  },
  {
    id: "webdev",
    title: "Full Stack Web Development",
    shortDesc: "HTML, CSS, JS, React, Node & DB",
    duration: "4 Months",
    price: "₹ 12,999",
    image: "https://cdn-icons-png.flaticon.com/512/919/919827.png",
    details: [
      "HTML, CSS, JavaScript",
      "React + Node.js + MongoDB",
      "Deploy & Final Portfolio"
    ],
    highlights: [
      "Live Projects",
      "Resume Projects",
      "Hosting Included"
    ]
  },
  {
    id: "datascience",
    title: "Data Science with Python",
    shortDesc: "Numpy, Pandas, ML & Visualization",
    duration: "2.5 Months",
    price: "₹ 13,499",
    image: "https://cdn-icons-png.flaticon.com/512/4248/4248443.png",
    details: [
      "Statistics, Numpy, Pandas",
      "Matplotlib, Seaborn, Scikit-learn",
      "ML Projects"
    ],
    highlights: [
      "Real Time Case Studies",
      "Capstone Project",
      "Certificate Included"
    ]
  },
  {
    id: "sql",
    title: "SQL & Database Fundamentals",
    shortDesc: "Master MySQL with Real-World Practice",
    duration: "1.5 Months",
    price: "₹ 5,999",
    image: "https://cdn-icons-png.flaticon.com/512/2772/2772128.png",
    details: [
      "DDL, DML, Joins, Aggregates",
      "Stored Procedures, Triggers",
      "Real-Time Data Problems"
    ],
    highlights: [
      "Practical Queries",
      "Hands-On Tasks",
      "Mock Test & Certification"
    ]
  },
  {
    id: "aws",
    title: "AWS Cloud Fundamentals",
    shortDesc: "Explore Core AWS Services & Deployment",
    duration: "2 Months",
    price: "₹ 10,499",
    image: "https://cdn-icons-png.flaticon.com/512/873/873120.png",
    details: [
      "EC2, S3, IAM, Lambda",
      "Hands-on Cloud Deployment",
      "Monitoring & Security"
    ],
    highlights: [
      "AWS Certified Trainers",
      "Lab Environment",
      "Project-Based Learning"
    ]
  },
  {
    id: "react",
    title: "ReactJS Mastery",
    shortDesc: "Build Powerful Frontends with React",
    duration: "1.5 Months",
    price: "₹ 7,999",
    image: "https://cdn-icons-png.flaticon.com/512/919/919851.png",
    details: [
      "JSX, Props, State, Hooks",
      "Router, Forms, API Integration",
      "Mini Project + Portfolio"
    ],
    highlights: [
      "Portfolio Projects",
      "Resume Ready Code",
      "Certificate of Completion"
    ]
  },
  {
    id: "cyber",
    title: "Cybersecurity Essentials",
    shortDesc: "Secure Systems and Prevent Attacks",
    duration: "2 Months",
    price: "₹ 8,999",
    image: "https://cdn-icons-png.flaticon.com/512/542/542689.png",
    details: [
      "Ethical Hacking Basics",
      "Network Security, Firewalls",
      "Simulated Attacks"
    ],
    highlights: [
      "Hands-On Practice",
      "Latest Tools",
      "Certification"
    ]
  },
  {
    id: "ai",
    title: "Artificial Intelligence Intro",
    shortDesc: "Learn AI Concepts with Practical Tools",
    duration: "2 Months",
    price: "₹ 11,999",
    image: "https://cdn-icons-png.flaticon.com/512/1674/1674291.png",
    details: [
      "Search Algorithms, Game AI",
      "NLP Basics",
      "Project on AI Applications"
    ],
    highlights: [
      "Concept + Code",
      "AI Toolkit Access",
      "Project Based"
    ]
  },
  {
    id: "excel",
    title: "Advanced Excel & Power BI",
    shortDesc: "Master Excel Dashboards and BI Tools",
    duration: "1.5 Months",
    price: "₹ 6,499",
    image: "https://cdn-icons-png.flaticon.com/512/732/732220.png",
    details: [
      "Excel Formulas, Pivot, VLOOKUP",
      "Power BI, Data Viz",
      "Project Report"
    ],
    highlights: [
      "Excel Templates",
      "Project Submission",
      "Certification Included"
    ]
  }
];

export default courseList;
